var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.25C6.86536 0.250152 6.73324 0.286547 6.61751 0.355365C6.50178 0.424183 6.40671 0.522886 6.34229 0.641113L0.365723 11.0986L0.367188 11.1001C0.291133 11.2197 0.250502 11.3583 0.25 11.5C0.25 11.6989 0.329018 11.8897 0.46967 12.0303C0.610322 12.171 0.801088 12.25 1 12.25H5.5L7 4L8.5 12.25H13C13.1989 12.25 13.3897 12.171 13.5303 12.0303C13.671 11.8897 13.75 11.6989 13.75 11.5C13.7502 11.358 13.7101 11.2188 13.6343 11.0986L7.66797 0.660156C7.60529 0.536837 7.50972 0.433257 7.39183 0.360871C7.27394 0.288485 7.13834 0.250114 7 0.25ZM8.5 12.25H5.5L6.51514 14.2041C6.71914 14.5964 7.28015 14.5964 7.4834 14.2041L8.5 12.25Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.72f3d657f2496a68a4f2112ace7a3adc.svg";
export { ForwardRef as ReactComponent };